// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconDevices = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 24 24' ref={ref} {...props}>
        <path
            fill='currentcolor'
            d='M4 1.5c-1.655 0-3 1.345-3 3v3c0 1.655 1.345 3 3 3h16c1.655 0 3-1.345 3-3v-3c0-1.655-1.345-3-3-3zm11.125 5.625A1.12 1.12 0 0 1 14 6c0-.623.502-1.125 1.125-1.125S16.25 5.377 16.25 6s-.502 1.125-1.125 1.125M19.625 6c0 .623-.502 1.125-1.125 1.125A1.12 1.12 0 0 1 17.375 6c0-.623.502-1.125 1.125-1.125s1.125.502 1.125 1.125M4 13.5c-1.655 0-3 1.345-3 3v3c0 1.655 1.345 3 3 3h16c1.655 0 3-1.345 3-3v-3c0-1.655-1.345-3-3-3zm11.125 5.625A1.12 1.12 0 0 1 14 18c0-.623.502-1.125 1.125-1.125s1.125.502 1.125 1.125-.502 1.125-1.125 1.125M20 18c0 .623-.502 1.125-1.125 1.125A1.12 1.12 0 0 1 17.75 18c0-.623.502-1.125 1.125-1.125S20 17.377 20 18'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconDevices)
const Memo = memo(ForwardRef)
export default Memo
